import React from 'react';

export default function MobileProductField({
  label,
  value,
  onChange,
  multiline,
  children,
  required = false,
  ...props
}) {
  const Input = multiline ? 'textarea' : 'input';
  return (
    <label className='mp-field'>
      <span className={required ? 'quantity-change-required-label' : undefined}>{label}</span>
      {children || (
        <Input
          className='form-control'
          value={value ?? ''}
          onChange={event => onChange(event.target.value)}
          required={required}
          {...props}
        />
      )}
    </label>
  );
}
